import { render, staticRenderFns } from "./BotonListaCupones.vue?vue&type=template&id=3fa5da53&"
import script from "./BotonListaCupones.vue?vue&type=script&lang=js&"
export * from "./BotonListaCupones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports